import React, {useState, useEffect, useMemo} from 'react';
import {Surface3} from './Surface3';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Axios from 'axios';
import { FaList, FaFile, FaParagraph} from 'react-icons/fa';

import "./Surface3Wrapper.scss"

// import {runQuery} from './utils'
// import {basicInfoQuery} from './Queries'

//TODO: surface 3 needs to run in a wrapper which allows the user to choose between manifestations.
//TODO: rdf dbase needs to include first line numbers for paragraphs that start in the middle of al line.

const runQuery = (query) => {
  const sparqlEndpoint = "https://sparql.scta.info/ds/query"
  const queryPromise = Axios.get(sparqlEndpoint, { params: { "query": query, "output": "json" } })
  return queryPromise
}

const basicInfoQuery = (itemExpressionUri) => {
  // query info block, division, or item (possible also collection)
  const query = [
    "SELECT DISTINCT ?title ?structureType ?cmanifestation ?cmanifestationTitle ?manifestation ?manifestationTitle ?ctranscription ?manifestationCTranscription ?cdoc ?cxml ?expressionShortId ?longTitle ?topLevelExpression ?next ?previous ?inbox ?author ?authorTitle ?parent ",
    "WHERE { ",
    "<" + itemExpressionUri + "> <http://purl.org/dc/elements/1.1/title> ?title .",
    "<" + itemExpressionUri + "> <http://scta.info/property/structureType> ?structureType .",
    "<" + itemExpressionUri + "> <http://scta.info/property/hasCanonicalManifestation> ?cmanifestation .",
    "?cmanifestation <http://purl.org/dc/elements/1.1/title> ?cmanifestationTitle .",
    "<" + itemExpressionUri + "> <http://scta.info/property/hasManifestation> ?manifestation .",
    "?manifestation <http://purl.org/dc/elements/1.1/title> ?manifestationTitle .",
    // NOTE: the line below restricts the query result from including an option for manifestations that either don't manifest in a material item, and therefore do not have an image
    "?manifestation <http://scta.info/property/isOnZone> ?isOnZone .",
    "OPTIONAL {",
    "?manifestation <http://scta.info/property/hasCanonicalTranscription> ?manifestationCTranscription .",
    "?cmanifestation <http://scta.info/property/hasCanonicalTranscription> ?ctranscription .",
    "?ctranscription <http://scta.info/property/hasDocument> ?cdoc . ",
    "?ctranscription <http://scta.info/property/hasXML> ?cxml . ",
    "}",
    "<" + itemExpressionUri + "> <http://scta.info/property/shortId> ?expressionShortId .",
    "{",
      "<" + itemExpressionUri + "> <http://scta.info/property/isPartOfTopLevelExpression> ?topLevelExpression .",
    "}",
    "UNION",
    "{",
      "<" + itemExpressionUri + "> <http://scta.info/property/level> '1' .",
      "BIND(<" + itemExpressionUri + "> AS ?topLevelExpression) .", 
    "}",
    "OPTIONAL {",
    "<" + itemExpressionUri + "> <http://scta.info/property/longTitle> ?longTitle .",
    "}",
    "OPTIONAL {",
    "?topLevelExpression <http://www.loc.gov/loc.terms/relators/AUT> ?author .",
    "?author <http://purl.org/dc/elements/1.1/title> ?authorTitle .",
    "}",
    "OPTIONAL {",
    "<" + itemExpressionUri + "> <http://scta.info/property/next> ?next .",
    "}",
    "OPTIONAL {",
    "<" + itemExpressionUri + "> <http://scta.info/property/previous> ?previous .",
    "}",
    "OPTIONAL {",
    "<" + itemExpressionUri + "> <http://purl.org/dc/terms/isPartOf> ?parent .",
    "}",
    "<" + itemExpressionUri + "> <http://www.w3.org/ns/ldp#inbox> ?inbox . ",
    "}",
    "ORDER BY ?title"].join('');

    return query
  }

const  Surface3Wrapper = (props) => {
  const [manifestations, setManifestations] = useState([])
  const [focusedManifestation, setFocusedManifestation] = useState(props.focusedManifestation)
  const [annotationsDisplay, setAnnotationsDisplay] = useState(props.annotationsDisplay)
  const [userAddedExpressionId, setUserAddedExpressionId] = useState("")
  
  const focusedManifestationSlug = focusedManifestation?.split("/").pop();

  useEffect(() => {
    if (props.expressionid){
      getManifestations(props.expressionid)

    }
    // this conditional is here in case the paraent component wants to supply an already retrieved list of manifestations.
    else if (props.manifestations){
      setManifestations(props.manifestations)
      focusedManifestation ? setFocusedManifestation(focusedManifestation) : setFocusedManifestation(props.manifestations[0].manifestation)

    }
  }, [props.expressionid, props.manifestations])
  useEffect(() => {
    setAnnotationsDisplay(props.annotationsDisplay)
  }, [props.annotationsDisplay])
  useEffect(() => {
    // this condition here; because if no focusedManifestation is set, the initial load will choose manifestations[0] as default
    // the conditional here prevents overriding this selection when no default focusedManifestation prop is set
    if (props.focusedManifestation){
      setFocusedManifestation(props.focusedManifestation)
    }
  }, [props.focusedManifestation])


  const getManifestations = () => {
    const results = runQuery(basicInfoQuery(props.expressionid))
    results.then((d) => {
      const manifestations = d.data.results.bindings.map((b) => {
        return {
          manifestation: b.manifestation.value,
          manifestationTitle: b.manifestationTitle.value,
          transcription: b.manifestationCTranscription ? b.manifestationCTranscription.value : ""
        }
      })
      setManifestations(manifestations)
      
      // conditional here is check for the new manifestation with the same slug as the current focusedManifestation
      const newFocusedManifestation = manifestations.find((m) => m.manifestation.includes(focusedManifestationSlug))?.manifestation
      if (focusedManifestation && newFocusedManifestation){
        setFocusedManifestation(newFocusedManifestation) 
      }
      else{
        setFocusedManifestation(manifestations[0]?.manifestation)
      }
    })
  }
  const displayManifestationsList = () => {
    const list = manifestations.map((m) => {
      return <option key={"title-" + m.manifestation} value={m.manifestation}>{m.manifestationTitle}</option>
    })
    return list
  }
  const displayManifestation = () => {
    const manifestation = manifestations.map((m,idx) => {
      if (m.manifestation === focusedManifestation){
        //key is set to surface-container instead of surface-manifestation to avoid re-rendering the component when focusedManifestation changes
        return <Surface3 key={"surface-container"} 
        manifestationid={m.manifestation} 
        annotationsDisplay={annotationsDisplay} 
        width={props.width}
        lineFocusId={props.lineFocusId}
        startWord={props.startWord}
        endWord={props.endWord}/>
      }
      else{
        return null
      }
    })
    return manifestation
  }
  const handleSetFocusedManifestation = (e) => {
    if (props.handleChangeManifestation){
      props.handleChangeManifestation(e.target.value)
    }
    else{
     setFocusedManifestation(e.target.value)
    }
  }
  const handleSetAnnotationsDisplay = (viewType) => {
    if (props.handleToggleTextLinesView){
      props.handleToggleTextLinesView(viewType)
    }
    else{
     setAnnotationsDisplay(viewType)
    }
  }


    return (
      <div className={props.hidden ? "hidden" : "showing"}>
        {!props.hideSelectionList &&
        <div className="manifestationsList">
          <Form.Control size="sm" as="select" onChange={handleSetFocusedManifestation} value={focusedManifestation}>
            {displayManifestationsList()}
          </Form.Control>
        </div>
        }
        <div className="surfaceWrapper">
          {!props.hideDisplayChoice && focusedManifestation &&
            <div className="image-display-choice">
              <p><span title="Text Line View" onClick={() => {handleSetAnnotationsDisplay("lines")}}><FaList/></span></p>
              <p><span title="Paragraph View" onClick={() => {handleSetAnnotationsDisplay("paragraph")}}><FaParagraph/></span></p>
              <p><span title="Full Surface View" onClick={() => {handleSetAnnotationsDisplay("surface")}}><FaFile/></span></p>
            </div>
          }
          <div className="imagesDisplay">
            {displayManifestation()}
          </div>
        </div>
        
        {
          userAddedExpressionId && 
          <Surface3Wrapper 
            expressionid={userAddedExpressionId}
            annotationsDisplay={annotationsDisplay}
            width={props.width}
            hidden={false}
            isDependentSurface3={true}/>
        }
        {(!props.isDependentSurface3 && !props.hideCustomImageForm) &&
        <div style={{"borderBottom": "1px solid rgba(0, 0, 0, 0.1)", "borderTop": "1px solid rgba(0, 0, 0, 0.1)", marginTop: "5px", padding: "5px"}} >
          <p style={{fontSize: "12px"}}>Create custom user compare</p>
          <Form onSubmit={(() => setUserAddedExpressionId(value))} inline="true"> 
            <FormControl inline="true" size="sm" id="text" type="text" value={userAddedExpressionId} placeholder="expression id" className="mr-sm-2" onChange={(e) => {handleSetCustomExpressionId(e.target.value)}}/>
            <Button inline="true" size="sm"  type="submit" style={{margin: "2px"}}>Submit</Button>
          </Form>
        </div>
        }

      </div>
    );
  }

Surface3Wrapper.defaultProps = {
  expressionid: "",
  manifestations: [],
  hidden: false,
  focusedManifestation: "",
  annotationsDisplay: "paragraph",
  width: 500,
  isDependentSurface3: false,
  hideCustomImageForm: false
};

Surface3Wrapper.propTypes = {
  /**
  * @description expressionid
  */
  expressionid: PropTypes.string,
  /**
  * @description this can used INSTEAD of supplying an expressionid; manifestation info can be manually supplied 
  * if already known by containing component; using this will avoid an extra query call; to use, expressionid prop must be empty/undefined; if expressionid is supplied, manual supply of manifestations will be ignored
  * @deprecated while supplying the manifestations manually save a query call, it adds complexity that is better from the component to handle internally; thus this prop is depreciated and not highly recommended
  */
  manifestations: PropTypes.array,
  /**
  * boolean indicating whether or not compoment should be mounted by still hidden
  */
  hidden: PropTypes.bool,
  /**
  * indicates on which manifestation component to default focus.
  * manifestation value MUST be included in manifestations array
  * if not supplied, first manifestation in array will be supplied
  */
  focusedManifestation: PropTypes.string,
  /**
  * indicates what kind of display is desired, "lines, paragraph, surface/null"
  */

  annotationsDisplay: PropTypes.string,
  /**
  * @description desired image width
  */
  width: PropTypes.number,
  /**
   * @description true or false value to hide (true) or show (false) the drop down selection list.
   * this is useful if only one manifestation is being shown. For a single manifestation, it might be better to use the Surface3 component
   * but if you also want the view toggle buttons that come with the Surface3Wrapper the hideSelectionList=true can reduce the unnecessary list and save some space 
   */
  hideSelectionList: PropTypes.bool,
  /**
   * @description true or false value to hide (true) or show (false) the custom image addition form
   */
  hideCustomImageForm: PropTypes.bool,
  /**
   * @description: a true value value to indicate whether surface3 component is a custom user added component and therefore a child of a previous Surface3Wrapper component
   * default is value; if true, this will prevent the option to create another custom user added component
   */
  isDependentSurface3: PropTypes.bool,
  /**
  * optional prop to allow parent container to reset default view prop
  */
  handleToggleTextLinesView: PropTypes.func,
  /**
  * optional prop to allow parent container to reset default manifestation view
  */
  handleChangeManifestation: PropTypes.func,
  /**
  * @descriptions props.startWord is the word token position that the desired passage begins on
  */
  startWord: PropTypes.number,
  /**
  * @descriptions props.endWord is the word token position that the desired passage begins on
  */
  endWord: PropTypes.number
}

export {Surface3Wrapper};
